// @ts-check
import apiClient from "./apiClient";

/**
 * @param {{ limit?: number; offset?: number; q?: string; sort?: string }} params
 * @returns {Record<string, any>}
 */
const buildListParams = (params = {}) => {
  const result = {};
  if (params.limit !== undefined) result.limit = params.limit;
  if (params.offset !== undefined) result.offset = params.offset;
  if (params.q !== undefined) result.q = params.q;
  if (params.sort !== undefined) result.sort = params.sort;
  return result;
};

/**
 * @param {number} frameworkId
 * @param {{ limit?: number; offset?: number; q?: string; sort?: string }} params
 * @returns {Promise<import("./types").PaginatedResponse<import("./types").RequirementRead>>}
 */
export async function getRequirements(frameworkId, params = {}) {
  const response = await apiClient.get(`/frameworks/${frameworkId}/requirements`, {
    params: buildListParams(params),
  });
  return response.data;
}

/**
 * @param {number} frameworkId
 * @param {import("./types").RequirementCreate} data
 * @returns {Promise<import("./types").RequirementRead>}
 */
export async function createRequirement(frameworkId, data) {
  const response = await apiClient.post(`/frameworks/${frameworkId}/requirements`, data);
  return response.data;
}

/**
 * @param {number} frameworkId
 * @param {number} requirementId
 * @param {import("./types").RequirementUpdate} data
 * @returns {Promise<import("./types").RequirementRead>}
 */
export async function updateRequirement(frameworkId, requirementId, data) {
  const response = await apiClient.patch(
    `/frameworks/${frameworkId}/requirements/${requirementId}`,
    data
  );
  return response.data;
}

/**
 * @param {number} frameworkId
 * @param {number} requirementId
 * @returns {Promise<void>}
 */
export async function deleteRequirement(frameworkId, requirementId) {
  await apiClient.delete(`/frameworks/${frameworkId}/requirements/${requirementId}`);
}

/**
 * @param {number} requirementId
 * @returns {Promise<import("./types").RequirementRead>}
 */
export async function getRequirement(requirementId) {
  const response = await apiClient.get(`/requirements/${requirementId}`);
  return response.data;
}
